import moment from 'moment';

angular.module('wbControllers').controller('ClientsController',
  ['$scope', '$routeParams', '$window', '$location', 'feeSchedule', 'AccountApplication', 'Client', 'User', 'InvestmentAccount', 'ClientDetails', 'PartnerChannel', 'Kyc', 'users',
    ($scope, $routeParams, $window, $location, feeSchedule, AccountApplication, Client, User, InvestmentAccount, ClientDetails, PartnerChannel, Kyc, users) => {
      let selectedAccountIds = [];
      const KYC_DATE_FORMAT = 'MMM D, YYYY, h:mma';

      function getClientDetails() {
        return ClientDetails.get({
          id: $routeParams.id,
        }, clientDetails => {
          $scope.partnerChannelsList = clientDetails.partnerChannelsList;
          $scope.selectPartnerChannelByID(clientDetails.partnerChannel);
          $scope.clientDetails = clientDetails;
          $scope.isShareInfoEnabled = clientDetails.externalAdvisor && clientDetails.externalAdvisor.shareInfo !== undefined;
          $scope.hasExternalAdvisor = !!clientDetails.externalAdvisor;
          $scope.externalAdvisor = clientDetails.externalAdvisor;
          $scope.isRevertingAccountStatus = false;
          $scope.updatingAccountId = null;
          $scope.revenuePotential = feeSchedule.calculateFees(clientDetails.investableAssets) / 12;
          $scope.blendedRate = feeSchedule.calculateBlendedRate(clientDetails.investableAssets);
          $scope.auditTypes = [
            {
              name: 'Identification',
              target: 'eid-checks',
              status: clientDetails.userEidCheckStatus,
            },
            {
              name: 'Watchlist',
              target: 'watchlist-checks',
              status: clientDetails.userWatchlistCheckStatus,
            },
          ];

          let dashboardReminderTriggered = clientDetails.kyc.dashboardReminderTriggered.default;
          if (clientDetails.kyc.dashboardReminderTriggered.at) {
            dashboardReminderTriggered = clientDetails.kyc.dashboardReminderTriggered.label.replace(
              '<DATE>',
              moment(clientDetails.kyc.dashboardReminderTriggered.at).format(KYC_DATE_FORMAT),
            );
          }

          let lastKycEmailSent = clientDetails.kyc.lastKycEmailSent.default;
          if (clientDetails.kyc.lastKycEmailSent.at) {
            lastKycEmailSent = clientDetails.kyc.lastKycEmailSent.label.replace(
              '<DATE>',
              moment(clientDetails.kyc.lastKycEmailSent.at).format(KYC_DATE_FORMAT),
            );
          }

          let workflowCompleted = clientDetails.kyc.workflowCompleted.default;
          if (clientDetails.kyc.workflowCompleted.at) {
            workflowCompleted = clientDetails.kyc.workflowCompleted.label.replace(
              '<DATE>',
              moment(clientDetails.kyc.workflowCompleted.at).format(KYC_DATE_FORMAT),
            );
          }

          let pmReview = clientDetails.kyc.pmReview.label || clientDetails.kyc.pmReview.default;
          if (clientDetails.kyc.pmReview.at) {
            pmReview = clientDetails.kyc.pmReview.label.replace(
              '<DATE>',
              moment(clientDetails.kyc.pmReview.at).format(KYC_DATE_FORMAT),
            );
          }
          $scope.kyc = {
            dashboardReminderTriggered,
            lastKycEmailSent,
            workflowCompleted,
            pmReview,
          };

          if (selectedAccountIds.length > 0) {
            $scope.clientDetails.investmentAccounts.forEach((investmentAccount) => {
              if (selectedAccountIds.indexOf(investmentAccount.id) > -1) {
                investmentAccount.selected = true;
              }
            });
          }
          return clientDetails;
        }).$promise;
      }

      $scope.toggleAccount = (account) => {
        account.selected = account.selected ? !account.selected : true;
      };

      $scope.onSelect = (item) => $location.url(`clients/${item.id}`);

      $scope.toggleBetaAccess = () => {
        $scope.clientDetails.roles = _.xor($scope.clientDetails.roles, ['beta']);
        Client.update({
          id: $routeParams.id,
          roles: $scope.clientDetails.roles,
        }, () => getClientDetails());
      };

      $scope.toggleExcludeFromBilling = () => User.update({
        id: $routeParams.id,
        excludeFromBilling: $scope.clientDetails.isExcludedFromBilling,
      }, () => getClientDetails());

      $scope.toggleApplication = (app) => {
        if ($scope.applicationShown(app)) {
          $scope.showAppId = null;
        }
        $scope.showAppId = app.id;
      };

      $scope.applicationShown = app => $scope.showAppId === app.id;

      $scope.applicationCancel = app => app.$delete(() => _.remove($scope.applications, a => a.id === app.id));
      $scope.clearPayment = app => AccountApplication.update(
        { id: app.id, payment: '' },
        () => { app.payment = ''; },
      );

      $scope.dumpIntercomConversations = () => {
        $scope.intercomDumpRequested = true;
        return User.export({ id: $routeParams.id });
      };

      $scope.selectAccountForEditing = (account) => {
        // Best practice is to use a sub-object of $scope to handle all dynamic fields.
        // For now, we're using a consistent editingAccount object to accomplish the same thing
        // for this particular field.
        // TODO Rewrite this component to be more idiomatic
        Object.assign($scope.editingAccount, {
          id: account.id,
          transit: account.transitNumber,
          institution: account.institutionNumber,
          accountNumber: account.accountNumber,
          currencyCode: account.currencyCode,
          portfolio: String(account.portfolioModelId),
          accountType: account.accountType,
          doNotTrade: account.doNotTrade,
          doNotTradeReason: account.doNotTradeReason,
          automateProfileChanges: account.automateProfileChanges,
          transferOut: account.transferOut,
        });
      };

      $scope.hasAnyBankInfoField = () => {
        const account = $scope.editingAccount;
        if (account) {
          return account.institution || account.transit || account.accountNumber;
        }
        return false;
      };

      $scope.stopEditingAccount = () => {
        $scope.editingAccount.id = null;
      };

      $scope.clearDoNotTradeReason = () => {
        $scope.editingAccount.doNotTradeReason = null;
      };

      $scope.translateAccountStatus = (status) => {
        if (status === 2) { return 'Pending'; }
        if (status === 3) { return 'Active'; }
        if (status === 4) { return 'Closed'; }
        return 'Unknown';
      };

      $scope.onAccountBlur = ($event) => {
        if ($event && $event.target && $event.target.value) {
          $event.target.value = $event.target.value.replace(/[^0-9]/g, '');
        }
      };

      $scope.saveAccountChanges = (editingAccount) => {
        $scope.updatingAccountId = editingAccount.id;
        selectedAccountIds = [];
        $scope.clientDetails.investmentAccounts.forEach((investmentAccount) => {
          if (investmentAccount.selected) {
            selectedAccountIds.push(investmentAccount.id);
          }
        });
        if (editingAccount.transit && editingAccount.institution && editingAccount.accountNumber) {
          InvestmentAccount.linkBankNumber({
            id: editingAccount.id,
            transitNumber: editingAccount.transit,
            institutionNumber: editingAccount.institution,
            accountNumber: editingAccount.accountNumber,
            currencyCode: editingAccount.currencyCode,
          }, () => getClientDetails());
        }

        if (editingAccount.portfolio === 'null') { // this is for "unknown" value
          editingAccount.portfolio = null;
        }

        InvestmentAccount.update({
          id: editingAccount.id,
          accountType: editingAccount.accountType,
          portfolioModelId: editingAccount.portfolio,
          doNotTrade: editingAccount.doNotTrade,
          doNotTradeReason: editingAccount.doNotTradeReason,
          automateProfileChanges: editingAccount.automateProfileChanges,
          transferOut: editingAccount.transferOut,
        }, () => getClientDetails());

        $scope.stopEditingAccount();
      };

      $scope.archiveUser = () => {
        User.delete({ id: $routeParams.id, archived: true });
      };

      $scope.restoreUser = () => {
        User.update({ id: $routeParams.id, archived: false });
      };

      $scope.disableTwoFactor = () => {
        User.disableTwoFactorAuth({ id: $routeParams.id });
        $scope.clientDetails.hasTwoFactorEnabled = false;
      };

      $scope.restore = app => AccountApplication.update(
        { id: app.id, archived: false },
        () => { app.archived = false; },
      );

      $scope.hasActiveInvestmentAccounts = () => {
        if ($scope.clientDetails) { return parseInt($scope.clientDetails.activeAccounts, 10) > 0; }
        return false;
      };

      $scope.hasDepositableInvestmentAccounts = () => {
        if ($scope.clientDetails && $scope.clientDetails.investmentAccounts && $scope.clientDetails.investmentAccounts.length > 0) {
          for (const account of $scope.clientDetails.investmentAccounts) {
            if (!account.archived) return true;
          }

          return false;
        }
        return false;
      };

      $scope.hasActiveTransfers = () => {
        if ($scope.clientDetails) { return parseInt($scope.clientDetails.activeTransfers, 10) > 0; }
        return false;
      };

      $scope.isArchivable = () => {
        if ($scope.clientDetails) {
          return parseInt($scope.clientDetails.activeTransfers, 10) === 0 && parseInt($scope.clientDetails.activeAccounts, 10) === 0;
        }
        return false;
      };

      $scope.lockAccount = () => {
        if ($scope.clientDetails) {
          $scope.clientDetails.lockedAt = true;
          ClientDetails.lockAccount({ id: $routeParams.id }, () => { getClientDetails(); });
        }
      };

      $scope.unlockAccount = () => {
        if ($scope.clientDetails) {
          $scope.clientDetails.lockedAt = null;
          ClientDetails.unlockAccount({ id: $routeParams.id }, () => { getClientDetails(); });
        }
      };

      $scope.selectPartnerChannelByID = (channelID) => {
        $scope.partnerChannel = $scope.partnerChannelsList.find((channel) => channel.id === channelID);
      };

      $scope.redirectToChangeEmail = () => {
        $window.location = `/app/staff/change-email/start?user_id=${$routeParams.id}`;
      };

      $scope.setUsersPartnerChannel = () => {
        if ($scope.partnerChannel.id && $scope.partnerChannel.id !== '') {
          PartnerChannel.setPartnerChannel(
            { id: $routeParams.id, partner_channel: $scope.partnerChannel.id },
            () => {
              getClientDetails();
              $scope.showPartnerChannelSelection = false;
            },
          );
        } else {
          PartnerChannel.deletePartnerChannel({ id: $routeParams.id }, () => {
            getClientDetails();
            $scope.showPartnerChannelSelection = false;
          });
        }
      };

      $scope.goToBankRequests = () => {
        $window.location = `/app/staff/bank-requests-by-user?user_id=${$scope.clientDetails.userId}`;
      };

      $scope.completePmReview = () => {
        Kyc.completePmReview({ id: $routeParams.id }, () => {
          getClientDetails();
        });
      };

      $scope.revertAccountStatus = (investmentAccountId) => {
        // disable the revert button
        $scope.isRevertingAccountStatus = true;
        const { email } = users.getCurrentUser();
        InvestmentAccount.revertClosedInvestmentAccount({
          id: investmentAccountId,
          email,
        }, () => getClientDetails()).$promise.finally(() => { $scope.isRevertingAccountStatus = false; });
      };

      function getIsMigrated(email) {
        users.isMigrated(email)
          .then(() => {
            $scope.isMigrated = true;
          }).catch(() => {
            $scope.isMigrated = false;
          });
      }

      function initialize() {
        $scope.showPartnerChannelSelection = false;
        $scope.showArchivedApplications = false;
        $scope.showArchivedInvestmentAccounts = false;
        $scope.showAppId = null;
        $scope.editingAccount = {};

        getClientDetails().then((clientDetails) => getIsMigrated(clientDetails.email));
      }

      initialize();
    }]);
